import { Edit } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'notistack';
import { Restore as RestoreIcon,Visibility as VisibilityIcon, Sync as SyncIcon  } from '@mui/icons-material';
import { Grid, Paper, Skeleton, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LessorCRU from './lessorCRU';
import SyncConfirmModal from './SyncConfirmModal';
import { globalGetService, globalPutService } from '../../../../utils/globalApiServices';
import { getLessorApi, putLessorApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { PermissionWrapper } from '../../../../wrappers';
import { PageLoader } from '../../../../shared_elements';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { trackActivity } from '../../../../utils/mixpanel';
import { fetchLeaseBasicDetails } from '../../../../shared_elements/actionCreators';



const Lessor = () => {
   const dispatch = useDispatch();
  const { leaseSlug } = useParams();
  const params = { leaseSlug };
  const [editLessor, setEditLessor] = useState({ mode: "", modal: false, data: {} });
  const [lessorData, setLessorData] = useState(null);
  const [syncLessor, setSyncLessor] = useState({ mode: "", modal: false, data: {} });
  const [isLoading,setLoading]=useState(false);
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  useEffect(() => {
    getLessorData();
  }, []);

  const getLessorData = () => {
    setLoading(true);
    globalGetService(getLessorApi(params?.leaseSlug))
      .then(response => {
        if (checkApiStatus(response)) {
          setLessorData(response?.data?.data || {});
          setLoading(false);
        }
      });
  }

  const handleSyncFunction = () => {
    setLoading(true);
    globalPutService(putLessorApi(leaseSlug, { 'cross_feature_check': 'lease_details' }))
      .then(async (response) => {
        if (checkApiStatus(response)) {
          getLessorData();
          dispatch(fetchLeaseBasicDetails({ slug: leaseSlug, setLoading }));
          setSyncLessor({ mode: "", modal: false, data: {} })
          enqueueSnackbar('Lessor info synchronized successfully.', { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `Lessor info synchronized`, success_msg: 'Lessor info synchronized successfully.', leaseSlug: leaseSlug, response: response?.data })
        } else {
          enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
        }
      })
  }
      
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Headlines`, page_type: page_type, })
  }
  return (
    <>
    {isLoading ? (
        <Paper sx={{ padding: 1, backgroundColor: "#FAFAFA", minHeight: "590px", width: "100%", boxShadow: "0px 0px 0px 1px #BBBBBB", margin: "1px", }} >
          <Grid sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} mb={2} >
            <Skeleton width={120} height={30} />
          </Grid>
          <Grid container spacing={2}>
            {[...Array(9)].map((_, i) => (
              <Grid key={i} size={{ md: 12, xs: 12 }}>
                <Skeleton variant="rectangular" height={40} sx={{ borderRadius: "8px" }} />
              </Grid>
            ))}
          </Grid>
        </Paper>
      ) : <>
      <Paper className="headline-readonly-fields" sx={{ padding: 1, minHeight: "490px", width: '100%', backgroundColor: '#FAFAFA', boxShadow: "0px 0px 0px 1px #BBBBBB",     margin: '1px' }}>
        <Grid sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', }} mb={2}>
          <Typography color="primary" fontSize='18px'>Lessor/Holdco</Typography>
          <Grid>
            <Tooltip title="Revision History">
              <RestoreIcon fontSize="small" className="revision-history" onClick={() => { setRevisionHistory({ modal: true, data: { slug: leaseSlug }, mode: 'view' }); handleItemClicked('Lessor RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} color="primary" />
            </Tooltip>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['U'] }}>
                  <Tooltip title="Sync">
                    <SyncIcon fontSize="small" className="revision-history" onClick={() => { setSyncLessor({ modal: true }); handleItemClicked('Lessor SyncIcon') }} sx={{ cursor: 'pointer' }} color="primary" />
                  </Tooltip>
                </PermissionWrapper>
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['R'] }}>
              <Tooltip title="View" arrow><VisibilityIcon sx={{ cursor: 'pointer' }} fontSize='small' color='primary' onClick={() => { setEditLessor({ modal: true, mode: "view", data: lessorData }); handleItemClicked('ViewIcon') }} /></Tooltip>
            </PermissionWrapper>
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['U'] }}>
              <Tooltip title="Edit">
                <Edit
                  onClick={() => { setEditLessor({ modal: true, mode: "edit", data: lessorData }); handleItemClicked('Lessor EditIcon') }}
                  fontSize="small"
                  color="primary"
                  sx={{ cursor: 'pointer' }} />
              </Tooltip>
            </PermissionWrapper>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                label="Name"
                varient="outlined"
                size="small"
                value={lessorData?.lessor_detail?.name || ""}
                margin="normal"
                slotProps={{ inputLabel: { shrink: true } }}
                disabled={true}
                fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Owner/SPV"
              variant='outlined'
              value={lessorData?.owner?.name || ""}
              disabled={true}
              size='small'
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Jurisdiction"
              varient="outlined"
              size='small'
              value={lessorData?.lessor_jurisdiction ? lessorData?.lessor_jurisdiction : ""}
              disabled={true}
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact (Email)"
              variant='outlined'
              value={lessorData?.lessor_contact_email ? lessorData.lessor_contact_email : ""}
              disabled={true}
              size='small'
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact (Phone)"
              variant='outlined'
              value={lessorData?.lessor_phone_number ? lessorData.lessor_phone_number : ""}
              disabled={true}
              size='small'
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact (Fax)"
              variant='outlined'
              value={lessorData?.lessor_contact_fax_number ? lessorData?.lessor_contact_fax_number : ""}
              disabled={true}
              size='small'
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Country of Incorporation"
              varient="outlined"
              size='small'
              value={lessorData?.lessor_country_of_incorporation ? lessorData?.lessor_country_of_incorporation : ""}
              disabled={true}
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="SPV"
              varient="outlined"
              size='small'
              value={lessorData?.spv ? lessorData?.spv : ""}
              disabled={true}
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth
            />
          </Grid>
          {lessorData?.ownership_type?.value === 2 && 
          <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                label="Portfolio"
                varient="outlined"
                size='small'
                value={lessorData?.lessor_portfolio ? lessorData?.lessor_portfolio : ""}
                disabled={true}
                margin='normal'
                slotProps={{ inputLabel: { shrink: true } }}
                fullWidth />
          </Grid>}
          {/* <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact Address"
              varient="outlined"
              value={lessorData?.lessor_contact_address ? lessorData?.lessor_contact_address : ""}
              disabled={true}
              size='small'
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid> */}
        </Grid>
      </Paper>
      </>}
      {
        editLessor?.modal ? <LessorCRU
          editLessor={editLessor}
          params={params?.leaseSlug}
          modeType={editLessor.mode}
          onToggleModal={() => setEditLessor({ ...editLessor, modal: false, data: null })}
          getResponseBack={getLessorData}
        /> : null
      }
      {revisionHistory?.modal ?
        <RevisionHistory
          moduleName={"lease"}
          revisionHistory={revisionHistory}
          onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          section_type='lessor'
        /> : null
      }
      {syncLessor?.modal ?
        <SyncConfirmModal
          sync={syncLessor}
          onToggleModal={() => setSyncLessor({ modal: false, mode: '', data: null })}
          sectionName='Lessor'
          getResponseBack={handleSyncFunction}
          isLoading={isLoading}
        /> : null
      }
    </>
  )
}

export default Lessor;